export const REQUEST_NAME = {
  AUTOCOMPLETE_OPTIONS: "fetchAutocompleteOptions",
};

export const REQUEST_KEYS = {
  TRIGGER: "trigger",
};
